import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const HomeCTA = () => {
  const { language } = useLanguage();

  const content = {
    ru: {
      title: 'Готовы к сотрудничеству?',
      text: 'Свяжитесь с нами для расчёта вашего проекта',
      button: 'Связаться'
    },
    kz: {
      title: 'Ынтымақтастыққа дайынсыз ба?',
      text: 'Жобаңызды есептеу үшін бізбен байланысыңыз',
      button: 'Байланысу'
    },
    en: {
      title: 'Ready to Cooperate?',
      text: 'Contact us to calculate your project',
      button: 'Contact Us'
    },
    ar: {
      title: 'هل أنتم مستعدون للتعاون؟',
      text: 'تواصلوا معنا لحساب تكلفة مشروعكم',
      button: 'تواصل معنا'
    }
  };

  const t = content[language] || content.en || content.ru;

  return (
    <section className="pt-6 py-2 pb-6 bg-[#061d36] text-white">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">{t.title}</h2>
        <p className="text-xl text-blue-200 mb-8">{t.text}</p>
        <Link 
          to="/contact"
          className="inline-flex items-center gap-2 px-8 py-4 bg-[#8B4444] hover:bg-[#7A3838] text-white rounded-xl font-semibold transition-colors"
          data-testid="home-cta-button"
        >
          {t.button}
          <ArrowRight className="w-5 h-5" />
        </Link>
      </div>
    </section>
  );
};

export default HomeCTA;
